/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GoogleOAuthDto = {
    /**
     * Google ID token received from Google Sign-In
     */
    id_token: string;
    /**
     * Device type for token handling
     */
    device_type?: GoogleOAuthDto.device_type;
    /**
     * FCM/APNs push notification token
     */
    device_token?: string;
    /**
     * Device name
     */
    device_name?: string;
};
export namespace GoogleOAuthDto {
    /**
     * Device type for token handling
     */
    export enum device_type {
        IOS = 'ios',
        ANDROID = 'android',
        WEB = 'web',
    }
}

